<template>
  <FaIcon icon="laptop-mobile" />
</template>
